"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _radioGroup = require("./radio-group");

var _radioModule = _interopRequireDefault(require("./radio.module.scss"));

var _excluded = ["checked", "disabled", "label", "hideLabel", "onChange", "className", "checkClassName", "value"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var noop = function noop() {};

var RadioButton = function RadioButton(_ref) {
  var _cx;

  var checked = _ref.checked,
      disabled = _ref.disabled,
      label = _ref.label,
      hideLabel = _ref.hideLabel,
      onChange = _ref.onChange,
      className = _ref.className,
      checkClassName = _ref.checkClassName,
      value = _ref.value,
      others = _objectWithoutProperties(_ref, _excluded);

  var _useContext = (0, _react.useContext)(_radioGroup.RadioGroupContext),
      contextOnChange = _useContext.onChange,
      contextValue = _useContext.value,
      contextDisabled = _useContext.disabled;

  var isChecked = checked || contextValue === value;
  var isDisabled = disabled || contextDisabled;
  return /*#__PURE__*/_react["default"].createElement("label", {
    className: (0, _classnames["default"])(_radioModule["default"].radioButton, className)
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({}, others, {
    value: value,
    className: _radioModule["default"].inputElement,
    type: "radio",
    disabled: isDisabled,
    checked: isChecked,
    onChange: noop,
    onClick: (0, _react.useCallback)(function () {
      onChange(!isChecked);
      contextOnChange(value);
    }, [contextOnChange, isChecked, onChange, value])
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])(_radioModule["default"].checkmark, checkClassName)
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])(_radioModule["default"].label, (_cx = {}, _defineProperty(_cx, _radioModule["default"].disabled, disabled), _defineProperty(_cx, 'sr-only', hideLabel), _cx), _defineProperty({}, _radioModule["default"].bold, checked))
  }, label));
};

RadioButton.propTypes = {
  className: _propTypes["default"].string,
  checkClassName: _propTypes["default"].string,
  checked: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  label: _propTypes["default"].node,
  hideLabel: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]).isRequired
};
RadioButton.defaultProps = {
  className: '',
  checkClassName: '',
  checked: false,
  disabled: false,
  label: '',
  hideLabel: false,
  onChange: noop
};
var _default = RadioButton;
exports["default"] = _default;